module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./statement.md");


//////////////////
// WEBPACK FOOTER
// ./client/models/content/statement.md
// module id = 447
// module chunks = 0